import './summary-area.scss'

import { get } from 'lodash'
import { FormApi } from 'final-form'
import { PropType } from 'vue'
import Component from 'vue-class-component'

import { CounterSignatureResource, ReportFeatured, Signer } from '@skinsoft/types'

import { ReactiveVue } from '@skinsoft/reactive-vue'
import { EnhancedTextArea, ThesaurusTermChooser, ThesaurusTermChooserList } from '@skinsoft/ui'
import { Signers } from '../fields-areas/signers'
import { CounterSignatures } from './counter-signatures'

@Component({
    components: {
        sEnhancedTextArea: EnhancedTextArea,
        sThesaurusTermChooser: ThesaurusTermChooser,
        sThesaurusTermChooserList: ThesaurusTermChooserList,
        sSigners: Signers,
        sCounterSignatures: CounterSignatures,
    },
    props: {
        type: Array,
        reportFeatured: {},
        form: {},
        fieldName: {},
        readOnly: {},
        signers: {
            type: Array as PropType<Signer[]>,
            default: [],
        },
        showSigners: {
            type: Boolean,
            default: false
        },
        counterSignatures: {
            type: Array as PropType<CounterSignatureResource[]>,
            default: [],
        },
        showCounterSignatures: {
            type: Boolean,
            default: false
        },
    },
    template: require('./summary-area.html')
})
export class SummaryArea extends ReactiveVue {

    public reportFeatured: ReportFeatured;
    public fieldName: string;
    public form: FormApi;
    private readOnly: Boolean
    private signers: Signer[]
    private showSigners: Boolean
    private counterSignatures: CounterSignatureResource[]
    private showCounterSignatures: Boolean

    public get observationsFieldName() {
        return `${this.fieldName}.conditionReportCS.comments[0.translatedString.${this.$i18n.locale}`
    }

    public get interventionsToScheduleFieldName() {
        return `${this.fieldName}.conditionReportCS.predictInterventions`
    }

    public get treatmentPriorityFieldName() {
        return `${this.fieldName}.conditionReportCS.treatmentPriority`
    }

    public get stateOfConservationFieldName() {
        return `${this.fieldName}.conditionReportCS.stateOfConservations`
    }

    public get interventionsToSchedule() {
        return get(this.form.getState().values, `${this.fieldName}.conditionReportCS.predictInterventions`)
    }

    public get precisionSubPath() {
        return `precision.translatedString.${this.$i18n.locale}`
    }
}